<div class="manage-projects">
    <div class="title centered-container">
        <h2>Manage Projects</h2>
    </div>
    <div class="centered-container" *ngIf="projects && !loading">
        <table class="table table-bordered table-striped projects">
            <thead>
                <th (click)="setOrder('id')">Id</th>
                <th (click)="setOrder('description')">Description</th>
                <th (click)="setOrder('createdDate')" class="center">Date</th>
                <th (click)="setOrder('daysLeft')" class="center days-left">Days Left</th>
                <th (click)="setOrder('prod')">Prod</th>
                <th (click)="setOrder('pointCount')">Points</th>
                <th (click)="setOrder('lineCount')">Lines</th>
                <th class="no-pointer">Renew</th>
                <th class="no-pointer">Delete</th>
            </thead>
            <ng-container *ngFor="let project of projects">
                <tr [class.mapped]="project.mapped">
                    <td>{{ project.id }}</td>
                    <td><a (click)="view(project)" title="View Project in Map"
                            *ngIf="project.prod">{{ project.description }}</a>
                        <span *ngIf="!project.prod">{{ project.description }}</span>
                    </td>
                    <td class="create-date">{{ project.createdDate | date:'yyyy-MM-dd' }}</td>
                    <td>{{ project.daysLeft }}</td>
                    <td>{{ project.prod }}</td>
                    <td>{{ project.pointCount }}</td>
                    <td>{{ project.lineCount }}</td>
                    <td class="button">
                        <button type="button" class="icon inverse rounded" (click)="renew(project)">
                            <span class="icon icon-ui-refresh"></span>
                        </button>
                    </td>
                    <td class="button">
                        <button type="button" class="icon inverse delete red rounded" (click)="delete(project)"
                            *ngIf="!currentProject || currentProject.id !== project.id">
                            <span class="icon icon-ui-trash"></span>
                        </button>
                    </td>
                </tr>
            </ng-container>
        </table>
        <button type="button" class="btn btn-primary go-back" (click)="toggleView('manage-projects');">
            <span class="icon icon-ui-left-arrow"></span>
            Go Back to PETL Processing
        </button>
    </div>
</div>